import { render } from "./Commandes.vue?vue&type=template&id=0551e316&scoped=true"
import script from "./Commandes.vue?vue&type=script&lang=js"
export * from "./Commandes.vue?vue&type=script&lang=js"

import "./Commandes.vue?vue&type=style&index=0&id=0551e316&scoped=true&lang=css"
import "./Commandes.vue?vue&type=style&index=1&id=0551e316&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0551e316"]])

export default __exports__